import { gql } from "@apollo/client";

export const getCatalog = gql`
  query getCatalog($catalogId: ID!) {
    getCatalog(catalogId: $catalogId) {
      brands
      campaignId
      catalogId
      catalogName
      createdBy
      createdDate
      decisionReason
      fulfillmentPartnerId
      fulfillmentRuleId
      inventoryManagedBy
      inventoryRollover
      inventoryType
      isAttached
      isDeleted
      lastModifiedBy
      lastModifiedDate
      partnerCatalogId
      partnerId
      programId
      status
      approvalStatus
      submittedAt
      approvedAt
      type
      pricing {
        price
        currency
        startDate
        endDate
      }
    }
  }
`;

export const filterCatalogs = gql`
  query FilterCatalogs($filter: CatalogFilters!, $sort: [String!]) {
    filterCatalogs(filters: $filter, sort: $sort) {
      total
      items {
        catalogId
        partnerCatalogId
        partnerId
        catalogName
        type
        decisionReason
        isDeleted
        isAttached
        createdDate
        lastModifiedDate
        createdBy
        lastModifiedBy
        status
        approvalStatus
        brands
        inventoryType
        inventoryManagedBy
        inventoryRollover
        fulfillmentPartnerId
        fulfillmentRuleId
        campaignId
        submittedAt
        approvedAt
      }
    }
  }
`;

export const getCatalogRewards = gql`
  query GetCatalogRewards($catalogId: ID!, $filter: CatalogRewardFilter) {
    getCatalogRewards(catalogId: $catalogId, filter: $filter) {
      total
      items {
        category
        rewardCategoryId
        description
        shortDescription
        fulfillmentRuleId
        fulfillmentPartnerId
        id
        isDeleted
        skuId
        imageUrl
        isActive
        lastModifiedDate
        name
        partnerId
        partnerName
        rewardCount
        rewardTypeId
        rewardTypeName
        rewardTypeData
        limit
        timeframe
        requiresProfileCompletion
        requiresTaxId
        autoClaim
        programId
        rewardUnitId
        rewardItemGroupId
        rewardItemGroup
        status
        approvalStatus
        selectable
        version
        parentRewardId
        approvedAt
        decisionReason
        inventoryEnforced
        requiresManualApproval
        requiresManualClaim
        pricing {
          pricingId
          price
          currency
          startDate
          endDate
          validFrom
          validTo
          isActive
          isInEffect
        }
      }
    }
  }
`;
